import React, { forwardRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

const PrintLabels = forwardRef(({ data }, ref) => {
    return (
        <div ref={ref}>
            {data.map((item) => (
                <div
                    key={item.id}
                    style={{
                        width: "101mm",
                        height: "53mm",
                        pageBreakAfter: "always",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div className="print-item flex items-center p-2 relative">

                        <QRCodeCanvas value={item.code} size={120} />

                        {/* Info di kanan */}
                        <div className="ml-2 text-xs font-bold bg-white px-1 rounded text-right">
                            <div>{item.code}</div>
                            <div className="text-[10px] font-normal">
                                {item.bins_name}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
});

export default PrintLabels;